import { z } from 'zod';
export const inspectDemoMetricValueSchema = z.object({
    available: z.boolean(),
    value: z.number().nullable(),
});
const qualityMetricsBlockSchema = z.object({
    intent_delivery_rate: inspectDemoMetricValueSchema,
    requirement_gap_rate: inspectDemoMetricValueSchema,
    adr_compliance: inspectDemoMetricValueSchema,
    rework_avoided: inspectDemoMetricValueSchema,
});
export const inspectDemoQualitySchema = z.object({
    surface: z.literal('quality'),
    fixture_version: z.string().min(1),
    headline: z.string(),
    metrics: qualityMetricsBlockSchema,
    scope_notes: z.array(z.string()).optional(),
});
export const inspectDemoBreakdownRowSchema = z.object({
    slice_id: z.string(),
    title: z.string(),
    rank: z.number().int().min(1).nullable().optional(),
    metrics: z.record(z.string(), inspectDemoMetricValueSchema),
});
export const inspectDemoBreakdownSurfaceSchema = z.enum([
    'leaderboard',
    'engineers',
    'teams',
    'repositories',
]);
export const inspectDemoBreakdownSchema = z.object({
    surface: inspectDemoBreakdownSurfaceSchema,
    fixture_version: z.string().min(1),
    rows: z.array(inspectDemoBreakdownRowSchema),
    empty_message: z.string().nullable().optional(),
});
//# sourceMappingURL=inspect-demo.js.map